import tree from 'state';

export default function isMobile() {
  const deviceType = tree.get(['browser', 'device', 'type']);
  return deviceType === 'mobile';
}
